
define('text!responsive-gameday-loginiframe/src/templates/gd_loginiframe_upsell.tpl',[],function () { return '<iframe src="/account/partner/fb/gdlogin_upsell.jsp" width="100%" height="1000"></iframe>';});

